import React from 'react';
import InvoicingStatusBox from './InvoicingStatusBox';

export const Approved = {
  component: InvoicingStatusBox,
  props: {
    status: 'approved',
    title: 'Testi Oy pays by invoice',
    text: 'Payment term 14 days.',
    children: (
      <ul style={{ margin: '12px 0 0', padding: 0, listStyle: 'none', fontSize: 14 }}>
        <li>Invoices to laskut@testi.fi</li>
        <li>Contact person Matti Meikäläinen</li>
      </ul>
    ),
    onContactSupport: () => null,
  },
  group: 'payment methods',
};

export const Pending = {
  component: InvoicingStatusBox,
  props: {
    status: 'pending',
    title: 'Request under review',
    text:
      'Our customer service will review the request and notify you. Until then you can pay by card.',
  },
  group: 'payment methods',
};

export const Denied = {
  component: InvoicingStatusBox,
  props: {
    status: 'denied',
    title: 'Invoicing not granted',
    text:
      "Invoicing could not be granted automatically because the company's revenue is below 2 million euros.",
    onContactSupport: () => null,
  },
  group: 'payment methods',
};
